export class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
    // Use event delegation for dynamically updated buttons
    this.addEventListener('click', (event) => {
      if (event.target.closest('.pgi-modal-add-to-cart')) {
        this.onAddToCartClick(event);
      }
      if (event.target.closest('.btn-size-add-to-cart')) {
        this.onModalOpenClick(event);
      }
      if (event.target.closest('.pgi-modal-close-btn')) {
        this.onModalCloseClick(event);
      }
    });
  }

  onModalOpenClick(event) {
    event.stopPropagation();
    event.preventDefault();
    document.querySelectorAll('.new-custom_size_selector_modal.pgi-modal-active').forEach(function(openModal){
      openModal.classList.remove('pgi-modal-active');
    });
    
    // Open this product's modal (find modal within this product-card)
    const modal = this.querySelector('.new-custom_size_selector_modal');
    if (modal) {
      modal.classList.add('pgi-modal-active');
    }
  }

  onModalCloseClick(event) {
    event.stopPropagation();
    event.preventDefault();
    console.log('onModalCloseClick');
    const modal = event.target.closest('.new-custom_size_selector_modal');
    if (modal) {
      modal.classList.remove('pgi-modal-active');
    }
  }

  onAddToCartClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const addToCartBtn = event.target.closest('.pgi-modal-add-to-cart');
    const { preOrderProduct, finalSale, newSizeVariant } = addToCartBtn.dataset;
    
    // Cache DOM elements
    const modal = addToCartBtn.closest('.new-custom_size_selector_modal');
    const elements = {
      addedText: modal?.querySelector('.pgi-modal-size-selector-added'),
      loader: modal?.querySelector('.new-quick-add-loader'),
      sizeWrap: modal?.querySelector('.pgi-modal-size-options-grid')
    };
    
    // Set loading state
    addToCartBtn.classList.add('adding-product');
    this.setLoadingState(elements, true);
    
    // Build form data with properties
    const properties = this.getProductProperties(preOrderProduct, finalSale);
    const formData = {
      items: [{
        id: newSizeVariant,
        quantity: 1,
        ...(properties && { properties })
      }]
    };
    
    // Add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then(data => {
      this.updateCartCount();
      this.setLoadingState(elements, false);
      addToCartBtn.classList.remove('adding-product');
      elements.addedText?.style && (elements.addedText.style.display = 'block');
    })
    .catch(error => {
      this.setLoadingState(elements, false);
      addToCartBtn.classList.remove('adding-product');
      console.error('Error adding to cart:', error);
    });
  }

  getProductProperties(preOrderProduct, finalSale) {
    if (preOrderProduct === 'preorder-product') {
      return { '_PRE ORDER': ' ' };
    }
    if (finalSale === 'final-sale') {
      return { '_FINAL SALE': ' ' };
    }
    return null;
  }

  setLoadingState(elements, isLoading) {
    const { sizeWrap, loader } = elements;
    if (sizeWrap) {
      sizeWrap.style.opacity = isLoading ? '0.3' : '1';
      sizeWrap.style.pointerEvents = isLoading ? 'none' : 'auto';
    }
    if (loader) {
      loader.style.display = isLoading ? 'flex' : 'none';
    }
  }

  updateCartCount() {
    const cartCountEl = document.querySelector('.header__desktop .header__cart__status');
    if (cartCountEl) {
      cartCountEl.textContent = parseInt(cartCountEl.textContent || 0) + 1;
    }
  }

  onSwatchClick(event) {
    const swatch = event.currentTarget;
    const swiperContainer = this.querySelector('.card-media-child swiper-container');
    const productAddBtn = this.querySelector('.new-custom_size_selector');
    const productPrice = this.querySelector('.card-pricing');
    const productVariants = this.querySelector('.pgi-modal-size-options-grid');
    const productUrl = this.querySelector('.pgi-modal-view-item-link');
    const productPopupImage = this.querySelector('.pgi-modal-product-img img');
    const cardMediaUrl = this.querySelector('.card-media');
    const cardTitleUrl = this.querySelector('.card-heading a');
    const swatchImages = swatch.dataset.swatchImages;
    const swatchPrice = swatch.dataset.swatchPrice;
    const swatchAddBtn = swatch.dataset.swatchAddBtn;
    const swatchVariants = swatch.dataset.swatchVariants;
    const swatchUrl = swatch.dataset.swatchUrl;
    const swatchPopupImage = swatch.dataset.swatchPopupImage;
    // Update selected state
    this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
    swatch.classList.add('selected');

    

    // Update product image - update slides instead of replacing entire slider
    if (swiperContainer && swatchImages && swiperContainer.swiper) {
      const swiper = swiperContainer.swiper;

      swiperContainer.classList.add('swiper-loading');
      
      // Create temporary container to parse new slides
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = swatchImages;
      const newSlides = tempDiv.querySelectorAll('swiper-slide');
      
      // Remove all existing slides
      swiper.removeAllSlides();
      
      // Add new slides
      const slidesArray = Array.from(newSlides).map(slide => slide.outerHTML);
      swiper.appendSlide(slidesArray);
      
      // Update swiper and reset to first slide
      swiper.update();
      swiper.slideTo(0, 0);
      swiperContainer.classList.remove('swiper-loading');
    }
    if (productAddBtn && swatchAddBtn) {
      productAddBtn.innerHTML = swatchAddBtn;
    }
    if (productPrice && swatchPrice) {
      productPrice.innerHTML = swatchPrice;
    }
    if (productVariants && swatchVariants) {
      productVariants.innerHTML = swatchVariants;
    }
    if (productUrl && swatchUrl) {
      productUrl.href = swatchUrl;
    }
    if (swatchUrl) {
      cardMediaUrl.href = swatchUrl;
      cardTitleUrl.href = swatchUrl;
    }

    if (productPopupImage && swatchPopupImage) {
      productPopupImage.src = swatchPopupImage;
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}